<template>
<div id="dailyrosterpopup">
    <div v-show="!pdfexport" class="dailyrosterpopup" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>
        <!-- <div v-if="loading" class="content">
            <div style="margin: auto; text-align: center;">LADE DATEN</div>
        </div> -->
        <div class="content" style="font-size:11px;">
            <div class="full">
                <div class="header">
                    <div class="label thin">{{ $t('roster.comp.daysCaps') }}</div>
                    <div class="label bold">{{ $t('roster.comp.rosterCaps') }}</div>





                    <div class="label created">
                        {{ $t('roster.comp.createdAt',[$helpers.getMomentTZ().format('DD.MM.YYYY'),$helpers.getMomentTZ().format('HH:mm')]) }}

                    </div>

                    <div v-tooltip="$t('roster.comp.nextDay')" class="label date" @click="changeDate(1)"><i class="fas fa-angle-right"></i></div>
                    <div class="label date">&nbsp;{{ date != null? date.format("ddd DD.MM.YYYY") : "" }}</div>
                    <div v-tooltip="$t('roster.comp.previousDay')" class="label date" @click="changeDate(-1)"><i class="fas fa-angle-left"></i></div>
                </div>
                <div class="subheader">
                    <div v-if="forcePortrait" v-tooltip="portraitTooltip()" class="fas fa-arrows-v" @click="forcePortrait = false"></div>
                    <div v-if="!forcePortrait" v-tooltip="portraitTooltip()" class="fas fa-arrows-h" @click="forcePortrait = true"></div>
                    <div v-tooltip="$t('roster.comp.switchColorMode')" class="fas fa-palette" @click="colorless = !colorless"></div>
                    <div v-tooltip="'PDF ' + $t('global.ui.save')" class="fas fa-file-download" @click="print()"></div>
                    <div v-tooltip="'CSV ' + $t('global.ui.save')" class="fas fa-file-csv" @click="printCsv()"></div>
                    <div v-tooltip="$t('roster.comp.unitShiftStart')" v-if="mode == 0" class="fas fa-business-time" @click="mode = 1;"></div>
                    <div v-tooltip="$t('roster.comp.unitShiftStart')" v-else class="fas fa-sitemap" @click="mode = 0;"></div>

                    <div v-tooltip="$t('roster.comp.toggleManagement')" v-if="onlyCrew" class="fas fa-user-alt" @click="onlyCrew = false;"></div>
                    <div v-tooltip="$t('roster.comp.toggleManagement')" v-else class="fas fa-user-alt-slash" @click="onlyCrew = true"></div>

                    <div v-tooltip="$t('roster.comp.toggleBreaksPunches')" v-if="onlyShifts" class="fas fa-utensils" @click="onlyShifts = false;"></div>
                    <div v-tooltip="$t('roster.comp.toggleBreaksPunches')" v-else class="fas fa-utensils-alt" @click="onlyShifts = true"></div>

                    <div v-tooltip="$t('roster.comp.toggleEvents')" v-if="activeEvent && showActiveEvent" class="fas fa-eye-slash" @click="showActiveEvent = false;"></div>
                    <div v-tooltip="$t('roster.comp.toggleEvents')" v-if="activeEvent && !showActiveEvent" class="fas fa-eye" @click="showActiveEvent = true"></div>

                    <div v-tooltip="$t('roster.comp.toggleUnpublishedShifts')" v-if="onlyPublic" class="fas fa-eye-slash" @click="onlyPublic = false;"></div>
                    <div v-tooltip="$t('roster.comp.toggleUnpublishedShifts')" v-else class="fas fa-eye" @click="onlyPublic = true"></div>

                    <div v-tooltip="$t('roster.comp.togglePositions')" v-if="showSpot" class="fas fas fa-map-marker-alt-slash" @click="showSpot = false"></div>
                    <div v-tooltip="$t('roster.comp.togglePositions')" v-else class="fas fas fa-map-marker-alt" @click="showSpot = true"></div>

                </div>
                <div class="subheader" style="height: 36px;" v-if="activeEvent && showActiveEvent">
                    <div class="label thin" v-bind:style="{color: colorless ? 'black' : ''}">{{activeEvent}} </div>
                </div>

                <div class="half" style="border-right: solid 2px black;">
                    <div v-bind:style="{background: colorless ? 'white' : 'var(--md)'}" class="full">
                        <div class="blocklabel" v-bind:style="{color: colorless ? 'black' : 'white'}">{{ $t('roster.comp.earlyShift') }}</div>
                    </div>

                    <div v-for="spot in Object.keys(earlyShifts)" v-bind:key="spot">
                        <div v-if="earlyShifts[spot].length > 0" class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : spotWithId(spot).color, color: colorless ? 'black' : $helpers.GetContrastingColor(spotWithId(spot).color, 'white', '#444444', 75)}">{{ spotWithId(spot).name }}</div>
                        </div>
                        <div v-for="shift in earlyShifts[spot]" v-bind:key="shift.id" class="full">
                            <div v-tooltip="shiftWorkValueTasksTooltipWrapper(shift)" class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="picture" v-bind:style="{ background: (employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].picture : 'url(../img/default.jpg)')}"></div>
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].lastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].firstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].spotId != null && spotMap[employeeMap[shift.employeeId].spotId]">
                                        &nbsp;<span v-if="showSpot">({{spotMap[employeeMap[shift.employeeId].spotId].name}}<i v-if="!colorless" class="fas fa-circle" v-bind:style="{color: spotMap[employeeMap[shift.employeeId].spotId].color, fontSize: '10px'}"/>)</span>
                                    </div>
                                    <div class="lastname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].dob != null && $helpers.getMomentFromStringTZ(employeeMap[shift.employeeId].dob).format('DD-MM') ==  date.format('DD-MM')">
                                        &nbsp;*{{ $t('roster.comp.birthdayCaps') }}*
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot? (' (' + shift.spot.name + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info" v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published || (shift.fromLocationId != null && locationMap[shift.fromLocationId])">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>
                                     <div v-if="shift.fromLocationId != null && locationMap[shift.fromLocationId]"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>Extern: {{locationMap[shift.fromLocationId].name}}</b>
                                    </div>
                                </div>


                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>



                                <div v-if="shift.tasks !== null && shift.tasks.length > 0" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="earlyExternalShifts.length > 0">
                        <div  class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : ''}">{{ $t('global.general.externalEmployee') }}</div>
                        </div>
                        <div v-for="shift in earlyExternalShifts" v-bind:key="shift.id" class="full">
                            <div v-tooltip="shiftWorkValueTasksTooltipWrapper(shift)" class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="picture" v-bind:style="{ background: (shift.employeePicture !== undefined ? GetProfilePictureUrl(shift.employeePicture) : 'url(../img/default.jpg)')}"></div>
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ shift.employeeLastName !== undefined ? shift.employeeLastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ shift.employeeFirstName !== undefined ? shift.employeeFirstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="shift.sourceStoreName">
                                        &nbsp;({{shift.sourceStoreName}})
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot ? (' (' + shift.spotName + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info" v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>

                                </div>



                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>


                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="half">
                    <div v-bind:style="{background: colorless ? 'white' : 'var(--md)'}" class="full">
                        <div class="blocklabel" v-bind:style="{color: colorless ? 'black' : 'white'}">{{ $t('roster.comp.lateShift') }}</div>
                    </div>
                    <div v-for="spot in Object.keys(lateShifts)" v-bind:key="spot">
                        <div v-if="lateShifts[spot].length > 0" class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : spotWithId(spot).color, color: colorless ? 'black' : $helpers.GetContrastingColor(spotWithId(spot).color, 'white', '#444444', 75)}">{{ spotWithId(spot).name }}</div>
                        </div>
                        <div v-for="shift in lateShifts[spot]" v-bind:key="shift.id" class="full">
                            <div v-tooltip="shiftWorkValueTasksTooltipWrapper(shift)" class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="picture" v-bind:style="{ background: (employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].picture : 'url(../img/default.jpg)')}"></div>
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].lastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].firstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].spotId != null && spotMap[employeeMap[shift.employeeId].spotId]">
                                        &nbsp;<span v-if="showSpot">({{spotMap[employeeMap[shift.employeeId].spotId].name}}<i v-if="!colorless" class="fas fa-circle" v-bind:style="{color: spotMap[employeeMap[shift.employeeId].spotId].color, fontSize: '10px'}"/>)</span>
                                    </div>
                                    <div class="lastname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].dob != null && $helpers.getMomentFromStringTZ(employeeMap[shift.employeeId].dob).format('DD-MM') ==  date.format('DD-MM')">
                                        &nbsp;*{{ $t('roster.comp.birthdayCaps') }}*
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot? (' (' + shift.spot.name + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info" v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published || (shift.fromLocationId != null && locationMap[shift.fromLocationId])">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>
                                     <div v-if="shift.fromLocationId != null && locationMap[shift.fromLocationId]"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>Extern: {{locationMap[shift.fromLocationId].name}}</b>
                                    </div>
                                </div>


                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>


                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="lateExternalShifts.length > 0">
                        <div  class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : ''}">{{ $t('global.general.externalEmployee') }}</div>
                        </div>
                        <div v-for="shift in lateExternalShifts" v-bind:key="shift.id" class="full">
                            <div v-tooltip="shiftWorkValueTasksTooltipWrapper(shift)" class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="picture" v-bind:style="{ background: (shift.employeePicture !== undefined ? GetProfilePictureUrl(shift.employeePicture) : 'url(../img/default.jpg)')}"></div>
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ shift.employeeLastName !== undefined ? shift.employeeLastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ shift.employeeFirstName !== undefined ? shift.employeeFirstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="shift.sourceStoreName">
                                        &nbsp;({{shift.sourceStoreName}})
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot? (' (' + shift.spotName + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info" v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>

                                </div>



                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>


                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div id="pdfroot" v-if="toggled && pdfexport " class="dailyrosterpopup pdf" v-bind:class="{portrait: printPortrait}" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}">
        <div class="background" v-on:click="Close()"></div>
        <div class="content" style="font-size:11px;">
            <div class="full">
                <div class="header" style="height: 36px;">
                    <div class="label thin" v-bind:style="{color: colorless ? 'black' : ''}">{{ $t('roster.comp.daysCaps') }}</div>
                    <div class="label bold" v-bind:style="{color: colorless ? 'black' : ''}">{{ $t('roster.comp.rosterCaps') }}</div>

                    <div class="label created" v-bind:style="{color: colorless ? 'black' : ''}">{{ $t('roster.comp.createdAt',[$helpers.getMomentTZ().format('DD.MM.YYYY'), $helpers.getMomentTZ().format('HH:mm')]) }}</div>
                    <div class="label date" v-bind:style="{color: colorless ? 'black' : ''}">&nbsp;{{ date != null? date.format("ddd DD.MM.YYYY") : "" }}</div>
                </div>
                <div class="subheader" style="height: 36px;">
                    <div class="label thin" v-bind:style="{color: colorless ? 'black' : ''}">{{storeSettings.name}}</div>
                    <div class="label thin"  v-bind:style="{color: colorless ? 'black' : ''}" v-if="activeEvent && showActiveEvent">{{" - "+activeEvent}}</div>

                </div>

                <div class="half" style="border-right: solid 2px black;">
                    <div v-bind:style="{background: colorless ? 'white' : 'var(--md)'}" class="full">
                        <div class="blocklabel" v-bind:style="{color: colorless ? 'black' : 'white'}">{{ $t('roster.comp.earlyShift') }}</div>
                    </div>
                    <div v-for="spot in Object.keys(earlyShifts)" v-bind:key="spot">
                        <div v-if="earlyShifts[spot].length > 0" class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : spotWithId(spot).color, color: colorless ? 'black' : $helpers.GetContrastingColor(spotWithId(spot).color, 'white', '#444444', 75)}">{{ spotWithId(spot).name }}</div>
                        </div>
                        <div v-if="earlyShifts[spot].length > 0" v-for="shift in earlyShifts[spot]" v-bind:key="shift.id" class="full">
                            <div class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].lastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].firstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].spotId != null && spotMap[employeeMap[shift.employeeId].spotId]">
                                        &nbsp;<span v-if="showSpot">({{spotMap[employeeMap[shift.employeeId].spotId].name}}<i v-if="!colorless" class="fas fa-circle" v-bind:style="{color: spotMap[employeeMap[shift.employeeId].spotId].color, fontSize: '10px'}"/>)</span>
                                    </div>
                                    <div class="lastname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].dob != null && $helpers.getMomentFromStringTZ(employeeMap[shift.employeeId].dob).format('DD-MM') ==  date.format('DD-MM')">
                                        &nbsp;*{{ $t('roster.comp.birthdayCaps') }}*
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot? (' (' + shift.spot.name + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info"v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published || (shift.fromLocationId != null && locationMap[shift.fromLocationId])">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>
                                     <div v-if="shift.fromLocationId != null && locationMap[shift.fromLocationId]"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>Extern: {{locationMap[shift.fromLocationId].name}}</b>
                                    </div>
                                </div>


                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>


                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="earlyExternalShifts.length > 0">
                        <div  class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : ''}">{{ $t('global.general.externalEmployee') }}</div>
                        </div>
                        <div v-for="shift in earlyExternalShifts" v-bind:key="shift.id" class="full">
                            <div class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ shift.employeeLastName !== undefined ? shift.employeeLastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ shift.employeeFirstName !== undefined ? shift.employeeFirstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="shift.sourceStoreName">
                                        &nbsp;({{shift.sourceStoreName}})
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot? (' (' + shift.spotName + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info" v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>

                                </div>



                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>


                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="half">
                    <div v-bind:style="{background: colorless ? 'white' : 'var(--md)'}" class="full">
                        <div class="blocklabel" v-bind:style="{color: colorless ? 'black' : 'white'}">{{ $t('roster.comp.lateShift') }}</div>
                    </div>
                    <div v-for="spot in Object.keys(lateShifts)" v-bind:key="spot">
                        <div v-if="lateShifts[spot].length > 0" class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : spotWithId(spot).color, color: colorless ? 'black' : $helpers.GetContrastingColor(spotWithId(spot).color, 'white', '#444444', 75)}">{{ spotWithId(spot).name }}</div>
                        </div>
                        <div v-if="lateShifts[spot].length > 0" v-for="shift in lateShifts[spot]" v-bind:key="shift.id" class="full">
                            <div class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].lastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ employeeMap[shift['employeeId']] !== undefined ? employeeMap[shift['employeeId']].firstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].spotId != null && spotMap[employeeMap[shift.employeeId].spotId]">
                                        &nbsp;<span v-if="showSpot">({{spotMap[employeeMap[shift.employeeId].spotId].name}}<i v-if="!colorless" class="fas fa-circle" v-bind:style="{color: spotMap[employeeMap[shift.employeeId].spotId].color, fontSize: '10px'}"/>)</span>
                                    </div>
                                    <div class="lastname" v-if="employeeMap[shift.employeeId] != null && employeeMap[shift.employeeId].dob != null && $helpers.getMomentFromStringTZ(employeeMap[shift.employeeId].dob).format('DD-MM') ==  date.format('DD-MM')">
                                        &nbsp;*{{ $t('roster.comp.birthdayCaps') }}*
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot? (' (' + shift.spot.name + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info" v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published || (shift.fromLocationId != null && locationMap[shift.fromLocationId])">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>
                                     <div v-if="shift.fromLocationId != null && locationMap[shift.fromLocationId]"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>Extern: {{locationMap[shift.fromLocationId].name}}</b>
                                    </div>
                                </div>


                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>


                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div v-if="lateExternalShifts.length > 0">
                        <div  class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : ''}">{{ $t('global.general.externalEmployee') }}</div>
                        </div>
                        <div v-for="shift in lateExternalShifts" v-bind:key="shift.id" class="full">
                            <div class="shiftrow" v-bind:style="{height: calculateShiftRowHeight(shift)}">
                                <div class="employeename" v-bind:style="{color: colorless ? 'black' : ''}">
                                    <div class="lastname">{{ shift.employeeLastName !== undefined ? shift.employeeLastName.toUpperCase() : '' }}</div>
                                    <div class="firstname">&nbsp;{{ shift.employeeFirstName !== undefined ? shift.employeeFirstName.toUpperCase() : '' }}</div>
                                    <div class="firstname" v-if="shift.sourceStoreName">
                                        &nbsp;({{shift.sourceStoreName}})
                                    </div>
                                </div>
                                <div class="shift" v-bind:style="{color: colorless ? 'black' : ''}">
                                    {{ shiftFromTo(shift) + (mode == 1 && showSpot ? (' (' + shift.spotName + ')') : '') }}

                                    <div class="break" v-if="!onlyShifts">
                                        {{ shiftBreak(shift) }}
                                    </div>
                                </div>
                                <div class="info" v-bind:style="{color: colorless ? 'black' : ''}" v-if="!shift.published">
                                    <div v-if="!shift.published"  v-bind:style="{display: 'inline-block', color: colorless? 'black' : 'red'}" >
                                        <b>{{ $t('roster.comp.unpublished') }}</b>
                                    </div>

                                </div>



                                <div v-if="shift.actual && !onlyShifts" class="actualwrapper">
                                    <div class="actual">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-clock"/>{{ shift.actual.startTime}}&nbsp; - {{ shift.actual.endTime }}
                                    </div>

                                    <div v-if="shift.actual.pauses.length > 0" class="actualpauses">
                                        <i v-bind:style="{color: colorless ? 'black' : ''}" class="fas fa-utensils"/>{{ pauses(shift) }}
                                    </div>
                                </div>


                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="unassigned-pdfroot" v-if="toggled && unassigned && pdfexport" class="dailyrosterpopup pdf" v-bind:class="{portrait: printPortrait}" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}">
        <div class="background" v-on:click="Close()"></div>
        <div class="content" style="font-size:11px;">
            <div class="full">
                <div class="header">
                    <div class="label thin">{{ $t('roster.comp.openCaps') }}</div>
                    <div class="label bold">SCHICHTEN</div>
                    <div class="label created">{{ $t('roster.comp.createdAt',[$helpers.getMomentTZ().format('DD.MM.YYYY'), $helpers.getMomentTZ().format('HH:mm')]) }}</div>
                    <div class="label date">&nbsp;{{ date != null? date.format(" DD.MM.YYYY") : "" }}</div>
                </div>
                <div class="half" style="border-right: solid 2px black;">
                    <div v-bind:style="{background: colorless ? 'white' : 'var(--md)'}" class="full">
                        <div class="blocklabel" v-bind:style="{color: colorless ? 'black' : 'white'}">{{ $t('roster.comp.earlyShift') }}</div>
                    </div>
                    <div v-for="spot in Object.keys(earlyShifts)" v-bind:key="spot">
                        <div v-if="earlyShifts[spot].length > 0" class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : spotWithId(spot).color, color: colorless ? 'black' : $helpers.GetContrastingColor(spotWithId(spot).color, 'white', '#444444', 75)}">{{ spotWithId(spot).name }}</div>
                        </div>
                        <div v-if="earlyShifts[spot].length > 0" v-for="shift in earlyShifts[spot]" v-bind:key="shift.id" class="full">
                            <div v-tooltip="shiftWorkValueTasksTooltipWrapper(shift)" class="shiftrow">
                                <div class="unassignedshift">
                                    {{ shiftFromTo(shift) + (mode == 1? (' (' + shift.spot.name + ')') : '') }}
                                    <div v-if="!shift.published && !shift.locked" style="display:inline-block;" v-on:click="editShift(shift);">
                                        <i class= "fas fa-edit" v-tooltip="$t('roster.comp.editShifts')"></i>
                                    </div>
                                </div>
                                <!--<div class="unassignedbreak">
                                    {{ shiftBreak(shift) }}
                                </div>-->
                                <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="half">
                    <div v-bind:style="{background: colorless ? 'white' : 'var(--md)'}" class="full">
                        <div class="blocklabel" v-bind:style="{color: colorless ? 'black' : 'white'}">{{ $t('roster.comp.lateShift') }}</div>
                    </div>
                    <div v-for="spot in Object.keys(lateShifts)" v-bind:key="spot">
                        <div v-if="lateShifts[spot].length > 0" class="full h20">
                            <div class="spotlabel" v-bind:style="{background: colorless ? 'white' : spotWithId(spot).color, color: colorless ? 'black' : $helpers.GetContrastingColor(spotWithId(spot).color, 'white', '#444444', 75)}">{{ spotWithId(spot).name }}</div>
                        </div>
                        <div v-if="lateShifts[spot].length > 0" v-for="shift in lateShifts[spot]" v-bind:key="shift.id" class="full">
                            <div class="shiftrow">
                                <div v-tooltip="shiftWorkValueTasksTooltipWrapper(shift)" class="shiftrow">
                                    <div class="unassignedshift">
                                        {{ shiftFromTo(shift) + (mode == 1? (' (' + shift.spot.name + ')') : '') }}
                                        <div v-if="!shift.published && !shift.locked" style="display:inline-block;" v-on:click="editShift(shift);">
                                            <i class= "fas fa-edit" v-tooltip="$t('roster.comp.editShifts')"></i>
                                        </div>
                                    </div>
                                    <!--<div class="unassignedbreak">
                                        {{ shiftBreak(shift) }}
                                    </div>-->
                                    <div v-if="shift.tasks !== null" class="task">
                                    {{ shiftTasks(shift) }}
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'dailyrosterpopup',
    components: {},
    data() {
        return {
            loading: true,
            toggled: false,
            elRelative: null,
            events: [],
            posx: 0,
            posy: 0,
            date: null,
            pdfexport: false,
            unassigned: false,
            mode: 0,

            actualPauses: [],

            onlyCrew: false,
            onlyShifts: false,
            forcePortrait: true,
            colorless: false,
            activeEvent: null,
            showActiveEvent: true,
            onlyPublic: false,
            showSpot: true
        }
    },
    created() {},
    destroyed() {},
    computed: {
        ...mapGetters([
                'imgCacheTimestamp',
                'employeeMap',
                'spotMap',
                'planShiftMap',
                'actualShiftMap',
                'actualBreakMap',
                'externalShiftMap',
                'storeSettings',
                'locationMap'

            ]),

        printPortrait() {
            return this.forcePortrait;//this.numEarlyShifts > 14 || this.numLateShifts > 14;
        },

        actualShifts(){
            let view = this;
            let actualShifts = [];
            const startOfDay = this.date.clone().startOf('day')
            const endOfDay = startOfDay.clone().add(1, 'days')
            Object.values(this.actualShiftMap).forEach( ashift => {

                let employee = view.employeeMap[ashift.employeeId];
                if(employee != null){
                     let from = view.$helpers.getMomentFromStringTZ(ashift.from);
                    let to = view.$helpers.getMomentFromStringTZ(ashift.to);
                    let as = {id: ashift.id, employeeId: ashift.employeeId, planshiftId: ashift.planshiftId, remoteId: ashift.remoteId, startDate: from, startTime: from.format('HH:mm'), employee: employee};
                    if(ashift.endMissing){
                        as.endDate = null;
                        as.endTime = "XX:XX"
                    } else {
                        as.endDate = to;
                        as.endTime = to.format('HH:mm');
                    }
                    if(from < endOfDay && from >= startOfDay){
                        let pauses = [];
                        Object.values(view.actualBreakMap).forEach(ab => {
                            if(ab.shiftId == ashift.id){
                                let bfrom = view.$helpers.getMomentFromStringTZ(ab.from);
                                let bto = view.$helpers.getMomentFromStringTZ(ab.to);
                                pauses.push({id: ab.id, startTime: bfrom.format("HH:mm"), endTime: bto.format("HH:mm")})
                            }
                        })
                        as.pauses = pauses;
                        actualShifts.push(as);
                    }

                }


            })
            return actualShifts;
        },
        activeEmployeeShiftMap(){
            let map = {};
            Object.values(this.planShiftMap).forEach(s => {
                if(s.employeeId){
                    let empl = this.employeeMap[s.employeeId];
                    let employeeLevel = (this.spotMap[s.spotId] ? this.spotMap[s.spotId].employeeLevel : 1);
                    let published = s.published && (this.spotMap[s.spotId] ? this.spotMap[s.spotId].exportToMp : true);
                    if(empl && empl.active && (!this.onlyCrew || employeeLevel == 1) && (!this.onlyPublic || published)) {
                        map[s.id] = s;
                    }
                } else {
                    map[s.id] = s;
                }
            });
            return map;
        },
        dayShiftsBySpot() {
            let view = this;
            let result = [];
            const shiftMap = this.activeEmployeeShiftMap;
            if(this.date){
                let dateKey = this.date.clone().format('YYYY-MM-DD')
                let shifts = [];
                Object.values(this.activeEmployeeShiftMap).forEach(s => {
                    let shiftCopy = Object.assign({}, s);
                    shiftCopy.fromDate = this.$helpers.getMomentFromStringTZ(shiftCopy.from);
                    shiftCopy.toDate = this.$helpers.getMomentFromStringTZ(shiftCopy.to);
                    if(dateKey == shiftCopy.fromDate.format('YYYY-MM-DD')){
                        if(view.unassigned && shiftCopy.employeeId == null){
                            shifts.push(shiftCopy)
                        } else if(!view.unassigned && shiftCopy.employeeId != null){
                            shifts.push(shiftCopy)
                        }
                    }

                })
                if(shifts.length > 0){
                    shifts.forEach((s) => {
                        let spot = view.spotMap[s.spotId];
                        let add = true;
                        result.forEach((r) => {
                            if(r.spot.id == spot.id){
                                add = false;
                                r.shifts.push(s)
                            }
                        });
                        if(add){
                            result.push({
                                shifts: [s],
                                spot: spot
                            });
                            }
                        });
                }

                // sort shifts in each group
                result.forEach((k) => {
                    k.shifts.sort((a,b) => {
                        if(a.fromDate < b.fromDate) return -1;
                        if(a.fromDate > b.fromDate) return 1;
                        return 0;
                    });
                });

                // sort list by sport sorter priority
                result.sort((a,b) => {
                    if(a.spot.priority > b.spot.priority) return 1;
                    if(a.spot.priority < b.spot.priority) return -1;
                    return 0;
                });
            }


            return result;
        },
        dayShiftsSorted(){
            let view = this;
            let shifts = [];
            const shiftMap = this.activeEmployeeShiftMap;
            if(this.date){
                let dateKey = this.date.clone().format('YYYY-MM-DD')
                Object.values(this.activeEmployeeShiftMap).forEach(s => {
                    let shiftCopy = Object.assign({}, s);
                    shiftCopy.fromDate = this.$helpers.getMomentFromStringTZ(shiftCopy.from);
                    shiftCopy.toDate = this.$helpers.getMomentFromStringTZ(shiftCopy.to);
                    if(dateKey == shiftCopy.fromDate.format('YYYY-MM-DD')){
                        if(view.unassigned && shiftCopy.employeeId == null){
                            shifts.push(shiftCopy)
                        } else if(!view.unassigned && shiftCopy.employeeId != null){
                            shifts.push(shiftCopy)
                        }
                    }

                })


                // sort shifts in each group
                shifts.sort((a,b) => {
                    if(a.fromDate < b.fromDate) return -1;
                    if(a.fromDate > b.fromDate) return 1;
                    return 0;
                });
            }
            return shifts;
        },
        numEarlyShifts() {
            let result = 0;
            this.dayShiftsBySpot.forEach((d) => {
                let shifts = d.shifts;
                shifts.forEach((s) => {
                    let h = s.fromDate.hour();
                    let m = s.fromDate.minute();
                    if (h < 12 || h == 12 && m == 0) result++;
                });
            });
            return result;
        },

        earlyShifts() {
            let result = {};
            this.dayShiftsBySpot.forEach((d) => {
                let spot = d.spot;
                if(this.mode == 1){
                    spot = {
                        id: 'nospot_mode_1',
                        name: '',
                        color: 'var(--contrast-5)'
                    };
                }
                if (!(spot.id in result)) result[spot.id] = [];
                let shifts = d.shifts;
                shifts.forEach((s) => {
                    let h = s.fromDate.hour();
                    let m = s.fromDate.minute();
                    s.spot = d.spot;
                    if(s.employeeId && this.employeeMap[s.employeeId]){
                        let actualShiftA =  this.actualShifts.find(as => as.employeeId == s.employeeId && this.startIsOnSameDay(s, as) && as.planshiftId == s.id);
                        if(actualShiftA){
                            s.actual = actualShiftA;
                        } else {
                            actualShiftA = this.actualShifts.find(as => as.employeeId == s.employeeId && this.startIsOnSameDay(s, as) && this.overlaps(s, as));
                            if(actualShiftA){
                                s.actual = actualShiftA;
                            } else {
                                s.actual = this.actualShifts.find(as => as.employeeId == s.employeeId && this.startIsOnSameDay(s, as))
                            }
                        }

                    } else {
                        console.log("employee not found: "+s.employeeId)
                    }

                    if (h < 12 || h == 12 && m == 0) result[spot.id].push(s);
                });
            });
            Object.keys(result).forEach((spotId) => {
                if(result[spotId].length == 0){
                    delete result[spotId];
                }else{
                    result[spotId].sort((a,b) => {
                        if(a.fromDate < b.fromDate) return -1;
                        if(a.fromDate > b.fromDate) return 1;
                        return 0;
                    });
                }
            });
            console.log(result)
            return result;
        },
        numLateShifts() {
            let result = 0;
            this.dayShiftsBySpot.forEach((d) => {
                let shifts = d.shifts;
                shifts.forEach((s) => {
                    let h = s.fromDate.hour();
                    let m = s.fromDate.minute();
                    if (h > 12 || h == 12 && m > 0) result++;
                });
            });
            return result;
        },
        lateShifts() {
            let result = {};
            this.dayShiftsBySpot.forEach((d) => {
                let spot = d.spot;
                if(this.mode == 1){
                    spot = {
                        id: 'nospot_mode_1',
                        name: '',
                        color: 'var(--contrast-5)'
                    };
                }
                if (!(spot.id in result)) result[spot.id] = [];
                let shifts = d.shifts;
                shifts.forEach((s) => {
                    s.spot = d.spot;
                    let h = s.fromDate.hour();
                    let m = s.fromDate.minute();
                    if(s.employeeId && this.employeeMap[s.employeeId]){
                        let actualShiftA =  this.actualShifts.find(as => as.employeeId == s.employeeId && this.startIsOnSameDay(s, as) && as.planshiftId == s.id);
                        if(actualShiftA){
                            s.actual = actualShiftA;
                        } else {
                            actualShiftA = this.actualShifts.find(as => as.employeeId == s.employeeId && this.startIsOnSameDay(s, as) && this.overlaps(s, as));
                            if(actualShiftA){
                                s.actual = actualShiftA;
                            } else {
                                s.actual = this.actualShifts.find(as => as.employeeId == s.employeeId && this.startIsOnSameDay(s, as))
                            }

                        }
                    } else {
                        console.log("employee not found: "+s.employeeId)
                    }

                    if (h > 12 || h == 12 && m > 0) result[spot.id].push(s);
                });
            });
            Object.keys(result).forEach((spotId) => {
                if(result[spotId].length == 0){
                    delete result[spotId];
                }else{
                    result[spotId].sort((a,b) => {
                        if(a.fromDate < b.fromDate) return -1;
                        if(a.fromDate > b.fromDate) return 1;
                        return 0;
                    });
                }
            });
            return result;
        },
        dailyExternalShifts() {
            let shifts = [];
            let view = this;
            if(this.date){
                let dateKey = this.date.clone().format('YYYY-MM-DD');
                Object.values(this.externalShiftMap).forEach((s) => {
                    let shiftCopy = Object.assign({}, s);
                    shiftCopy.fromDate = this.$helpers.getMomentFromStringTZ(shiftCopy.from);
                    shiftCopy.toDate = this.$helpers.getMomentFromStringTZ(shiftCopy.to);
                    if(dateKey == shiftCopy.fromDate.format('YYYY-MM-DD')){
                        if(!view.unassigned && shiftCopy.employeeId != null){
                            shifts.push(shiftCopy)
                        }
                    }
                });
            }
            return shifts;

        },
        lateExternalShifts() {
            let result = [];
            this.dailyExternalShifts.forEach((s) => {
                let h = s.fromDate.hour();
                let m = s.fromDate.minute();
                if (h > 12 || h == 12 && m > 0) result.push(s);

            });
            return result;
        },
        earlyExternalShifts() {
            let result = [];
            this.dailyExternalShifts.forEach((s) => {
                let h = s.fromDate.hour();
                let m = s.fromDate.minute();
                if (h < 12 || h == 12 && m == 0) result.push(s);

            });

            return result;
        }

    },
    methods: {
        calculateShiftRowHeight(shift){
            let base = 50;
            if(shift.actual != null && !this.onlyShifts){
                base +=15;
            }
            if(!shift.published || (shift.fromLocationId != null && this.locationMap[shift.fromLocationId])){
                base+=15;
            }
            if(shift.tasks != null && shift.tasks.length > 0){
                base +=15;
            }
            return base+'px';
        },
        portraitTooltip() {
            let view = this;
            return () => {
                if(view.forcePortrait) {
                    return "PDF " + this.$t('roster.comp.portraitFormat')
                } else {
                    return "PDF " + this.$t('roster.comp.landscapeFormat')
                }
            }
        },
        editShift(shift){
            this.$parent.OpenEditShiftPopup(shift);
        },
        Close() {
            //if($(window.mouse.element).closest('.statistics-popup').length > 0) return;
            this.Toggle(false);
        },
        Toggle(val) {
            if (val !== undefined || val !== null) {
                this.toggled = val;
                return;
            }
            this.toggled = !this.toggled;
        },
        spotWithId(spotId){
            let spot = this.spotMap[spotId];
            if(spot == undefined){
                // fallback
                spot = {
                    id: spotId,
                    name: '',
                    label: '',
                    color: 'var(--contrast-5)'
                }
            }
            return spot;
        },
        changeDate(days){
            let nextDate = this.date.clone().add(days, 'days');
            if(this.date.month() == nextDate.month()){

                this.date = nextDate;

            }
        },
        Init(date, unassigned = false, elRelative = null) {

            this.toggled = true;
            this.date = date;


            this.unassigned = unassigned;
            this.activeEvent = this.calculateActiveStoreEvent();
            console.log(this.activeEvent);
            if (elRelative) {
                this.elRelative = elRelative
            }



            this.Reposition();
        },
        calculateActiveStoreEvent(){
            let event = null;

            let storeEventMomentMap = this.$parent.storeEventMomentMap;


            let dateKey = this.date.format("YYYY-MM-DD")

            if(storeEventMomentMap && storeEventMomentMap[dateKey]){

                event = Object.values(storeEventMomentMap[dateKey]).find(e => e.active);

            }
            return event != null ? event.name : null;
        },

        startIsOnSameDay(shift, actualShift){
            let sFrom = shift.fromDate;
            let aFrom = actualShift.startDate;
            if(sFrom && aFrom){
                return (sFrom.year == aFrom.year && sFrom.month == aFrom.month && sFrom.day == aFrom.day);
            }
            return false;
        },
        overlaps(shift, actualShift){
            let sFrom = shift.fromDate;
            let sTo = shift.toDate;
            let aFrom = actualShift.startDate;
            let aTo = actualShift.endDate;
            if(sFrom && sTo && aFrom && aTo){
                return (sFrom < aTo && sTo > aFrom);
            }
            return false;
        },
        shiftFromTo(shift) {
            return shift.fromDate.format('HH:mm') + ' - ' + shift.toDate.format('HH:mm');
        },
        pauses(shift){
            let view = this;
            let pStr = "";
            let first = true;
            shift.actual.pauses.forEach((p) => {

                let startTime = p.startTime;
                let endTime = p.endTime;
                if(first){
                    first = false;
                }else{
                    pStr += ', ';
                }
                pStr += startTime+'-'+endTime;
            });
            return pStr;
        },
        actualFromTo(shift){
            let ft = '';
            if(shift.actual != null){
                let start = shift.actual.startTime;
                let end = shift.actual.endTime;
                ft += start;
                ft += " - ";
                ft += end;
            }
            return ft;
        },
        shiftBreak(shift) {
            if(shift.breakValue > 0){
                if (shift.breakFrom !== null) {
                    let bStart = this.$helpers.getMomentFromStringTZ(shift.breakFrom);
                    let bEnd = bStart.clone().add(shift.breakValue, 'minutes');
                    return '(Plan Pause: ' + bStart.format('HH:mm') + ' - ' + bEnd.format('HH:mm') + ')';
                } else{
                    let sFrom = this.$helpers.getMomentFromStringTZ(shift.from);
                    let sTo = this.$helpers.getMomentFromStringTZ(shift.to);
                    let bStart = sFrom.add(sTo.diff(sFrom, 'minutes')/2, 'minutes');
                    let bEnd = bStart.clone().add(shift.breakValue, 'minutes');
                    return '(Plan Pause: ' + bStart.format('HH:mm') + ' - ' + bEnd.format('HH:mm') + ')';
                }
            } else {
                return '';
            }

        },
        shiftTasks(shift){
            let tasks = "";
            if(shift.tasks != null){
                let elems = [];
                shift.tasks.forEach((t) => {
                    elems.push(t.label + ': ' + t.value);
                });
                tasks = elems.join(", ");
            }
            return tasks;
        },
        shiftWorkValueTasksTooltipWrapper(shift){
            let elems = [];
            if(shift.workValue > -1){
                let hours = Math.floor(shift.workValue / 60);
                let minutes = shift.workValue % 60;
                elems.push({
                    text: this.$t('roster.comp.workValue', [hours, minutes])
                });
            }
            if(shift.tasks != null && shift.tasks.length > 1){
                shift.tasks.forEach((t) => {
                    elems.push({
                        text: t.label + ': ' + t.value,
                        });
                });
            }
            if(elems.length > 0){
                return () => {
                    return {
                        components: [{
                            type: 'listlabel',
                            state: {labels: elems},
                            pinTopRight: true,
                        }],
                    };
                };
            }
            return null;
        },
        Reposition() {
            var view = this;
            requestAnimationFrame(function () {
                if (!view.elRelative) {
                    view.posx = (window.innerWidth / 2) - 500;
                    view.posy = 80;
                } else {
                    var box = view.elRelative.getBoundingClientRect();
                    view.posx = box.left + box.width + 5;
                    view.posy = box.top + 24;
                }
                view.$forceUpdate();
            });
        },

        print() {

            let view = this;
            view.pdfexport = true;
            this.$nextTick(() => {

                let el = view.unassigned? document.getElementById("unassigned-pdfroot") : document.getElementById("pdfroot");
                if(el != null){
                    html2canvas(el)
                    .then((canvas) => {
                        let imgData = canvas.toDataURL('image/png');

                        // resize to fit width/height
                        view.getImageDimensions(imgData, (width, height) => {
                            try {
                                let pdfMargin = 3;
                                var doc = new jsPDF(view.printPortrait ? 'p' : 'l');

                                let pdfWidth = doc.internal.pageSize.getWidth();
                                let pdfHeight = doc.internal.pageSize.getHeight();

                                let pdfPrintWidth = pdfWidth - (2*pdfMargin);
                                let pdfPrintHeight = pdfHeight - (2*pdfMargin);

                                var factor = width / height;

                                // fit width and height to page size
                                if(width > pdfPrintWidth){
                                    width = pdfPrintWidth;
                                    height = width / factor;
                                }
                                if(height > pdfPrintHeight){
                                    height = pdfPrintHeight;
                                    width = height * factor;
                                }
                                doc.addImage(imgData, 'PNG', pdfMargin, pdfMargin, width, height);
                                let filePrefix = view.unassigned? this.$t('roster.comp.openShifts') : this.$t('roster.comp.dailyRpl') + ' - ';
                                doc.save(filePrefix + view.$store.state.storeSettings.name + ' - ' + view.date.format('DD.MM.YYYY') + '.pdf');
                                view.pdfexport = false;
                            } catch (err) {
                                console.log("Errror during jsPDF")
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.comp.createPdfError'));
                                view.pdfexport = false;
                            }
                        });
                    }).catch((error) => {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.comp.createPdfError'));
                        view.pdfexport = false;
                        console.log(error)
                    });
                } else {
                    console.log("Could not find element!")
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.comp.createPdfError'));
                    view.pdfexport = false;
                }

            });
        },
        printCsv(){
            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            // e.address, e.postalCode, e.city, e.iban, e.bic,
            let shifts = this.dayShiftsSorted;
            let taskKeys = [];
            let csv = "Datum;Beginn;Ende;Arbeitszeit;Position;Mitarbeiter;veröffentlicht";
            if(shifts.length > 0){
                shifts.forEach(shift => {
                    if(shift.tasks != null){
                        shift.tasks.forEach(t => {
                            if(!taskKeys.includes(t.label)){
                                taskKeys.push(t.label);
                            }
                        });
                    }
                });
                taskKeys.forEach(k => {
                    csv += ";" + k;
                });
                csv += "\r\n";
                shifts.forEach(shift => {
                    let startM = shift.fromDate.clone();
                    let endM = shift.toDate.clone();

                    let workValue = this.$helpers.getMomentDuration(startM,endM);
                    let total = workValue.hours() * 60 + workValue.minutes();

                    if(shift.workValue != -1){ //Do not calculate - take stored value (z.B. Schulung)
                        total = shift.workValue;
                    }

                    if(shift.breakValue != -1 && shift.workValue == -1){
                        total = total - shift.breakValue;
                    }
                    total = Math.max(0, total);
                    shift.total = Math.max(0, total);

                    let hours = Math.floor(total / 60);
                    let minutes = total - (hours * 60);


                    let empl = view.employeeMap[shift['employeeId']];
                    let assignedEmployee = '';
                    if(empl != null && empl != undefined){
                        assignedEmployee = empl['lastName'] + ' ' + empl['firstName'];
                    }
                    let todos = "";
                    let curTasks = {};
                    taskKeys.forEach(k => {
                        curTasks[k] = '';
                    });
                    if(shift.tasks != null){
                        let first = true;
                        shift.tasks.forEach((t) => {
                            if(first){
                                first = false;
                            }else{
                                todos += ', ';
                            }
                            todos += t.label + ': ' + t.value;
                            curTasks[t.label] = t.value;
                        });
                    }
                    let cur = [

                        view.$helpers.extractDateStringTZ(shift['from'], 'DD.MM.YYYY'),
                        shift['fromDate'].format('HH:mm'),
                        shift['toDate'].format('HH:mm'),
                        hours + ':' + minutes,
                        view.spotMap[shift['spotId']]['name'],
                        assignedEmployee,
                        shift['published']? this.$t('global.ui.yes').toUpperCase():this.$t('global.ui.no').toUpperCase()

                    ];
                    taskKeys.forEach(k => {
                        cur.push(curTasks[k]);
                    });
                    csv += cur.join(";");
                    csv += "\r\n";
                });
            }
            if(this.dailyExternalShifts.length > 0){
                let shifts = this.dailyExternalShifts;
                shifts.sort((a,b) => {
                    if(a.fromDate < b.fromDate) return -1;
                    if(a.fromDate > b.fromDate) return 1;
                    return 0;
                });
                shifts.forEach(shift => {
                    if(shift.tasks != null){
                        shift.tasks.forEach(t => {
                            if(!taskKeys.includes(t.label)){
                                taskKeys.push(t.label);
                            }
                        });
                    }
                });
                taskKeys.forEach(k => {
                    csv += ";" + k;
                });
                csv += "\r\n";
                shifts.forEach(shift => {
                    let startM = shift.fromDate.clone();
                    let endM = shift.toDate.clone();

                    let workValue = this.$helpers.getMomentDuration(startM,endM);
                    let total = workValue.hours() * 60 + workValue.minutes();

                    if(shift.workValue != -1){ //Do not calculate - take stored value (z.B. Schulung)
                        total = shift.workValue;
                    }

                    if(shift.breakValue != -1 && shift.workValue == -1){
                        total = total - shift.breakValue;
                    }
                    total = Math.max(0, total);
                    shift.total = Math.max(0, total);

                    let hours = Math.floor(total / 60);
                    let minutes = total - (hours * 60);



                    let assignedEmployee = (shift.employeeLastName != null ? shift.employeeLastName :'') + ' ' + (shift.employeeFirstName != null ? shift.employeeFirstName :'');

                    let todos = "";
                    let curTasks = {};
                    taskKeys.forEach(k => {
                        curTasks[k] = '';
                    });
                    if(shift.tasks != null){
                        let first = true;
                        shift.tasks.forEach((t) => {
                            if(first){
                                first = false;
                            }else{
                                todos += ', ';
                            }
                            todos += t.label + ': ' + t.value;
                            curTasks[t.label] = t.value;
                        });
                    }
                    let cur = [

                        view.$helpers.extractDateStringTZ(shift['from'], 'DD.MM.YYYY'),
                        shift['fromDate'].format('HH:mm'),
                        shift['toDate'].format('HH:mm'),
                        hours + ':' + minutes,
                        shift.sourceStoreName,
                        assignedEmployee,
                        shift['published']? this.$t('global.ui.yes').toUpperCase():this.$t('global.ui.no').toUpperCase()

                    ];
                    taskKeys.forEach(k => {
                        cur.push(curTasks[k]);
                    });
                    csv += cur.join(";");
                    csv += "\r\n";
                });
            }

            let dateStr = this.date != null? this.date.format(" DD.MM.YYYY") : "";
            var date = new Date();
            let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + '-' + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );

            let filename = "Tagesdienstplan_" + dateStr + "_" + view.$store.state.storeSettings.name + '_' + ts + ".csv";
            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        getImageDimensions(url, callback) {
            var sourceImage = new Image();
            sourceImage.onload = function() {
                let width = this.width;
                let height = this.height;
                callback(width, height);
            }
            sourceImage.src = url;
        },
        GetProfilePictureUrl(employeePicture){
            if(!employeePicture || !employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
            return 'var(--contrast-1) no-repeat center/cover  url(' + employeePicture.server + '/api/file?id='+ employeePicture.fileId +'&accessToken='+employeePicture.accessToken +"&thumb=small"+ '&time='+this.imgCacheTimestamp+')';
        },
    },
    mounted() {
        $('body').append(this.$el);

    },
    beforeDestroy() {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dailyrosterpopup {
    position: fixed;
    display: inline-block;
    max-height: 85%;
    width: 1100px;
    display: none;
    z-index: 1000 !important;
    background: var(--bg);
    color: var(--col-label-default);
    box-shadow: 0px 0px 1000px 1000px rgba(0, 0, 0, 0.5);
    border: solid 1px black;
    padding: 15px;

    top: 120px;
    left: 78px;
    overflow-y: auto;
}

.dailyrosterpopup.pdf {
    max-height: 5000px;
    width: 1100px;
    background: var(--bg);
    box-shadow: none;
}

.dailyrosterpopup.pdf.portrait {
    max-height: 5000px;
    width: 775px;
}

.blocklabel {
    margin: 2px 0px 0px 6px;
    font-family: DistrictProBold;
    font-size: 18px;
    color: white;
}

.spotlabel {
    padding: 0px 0px 0px 6px;
    font-size: 14px;
    height: 20px;
    font-family: DistrictProBold;
    color: var(--contrast-4);
    background: var(--contrast-3);
    border-bottom: solid 2px black;

}

.background {
    position: fixed;
    height: 100vh;
    width: 100vw;
    left: 0;
    right: 0;
    z-index: -1;
    top: 0;
}

.fas {
    margin-top: 6px;
    margin-left: 10px;
    font-size: 19px;
    color: var(--md);
}

.fas:hover {
    color: var(--contrast-4);
}

.pdf .background {
    color: white;
}

.full>.header {
    box-shadow: none;
    width: 100%;
    height: 45px;
    margin-bottom: 0px;
    margin-top: 10px;
}

.full>.subheader {
    box-shadow: none;
    width: 100%;
    height: 45px;
    margin-bottom: 0px;
    margin-top: 0px;
}

.header .label {
    font-family: DistrictProBold;
    font-size: 24px;
    color: #6d8d23;
}

.subheader .label {
    font-family: DistrictProBold;
    font-size: 24px;
    color: #6d8d23;
}

.header .label.thin {
    display: inline;
    font-family: DistrictProBook;
    font-weight: 100;
    font-size: 24px;
}

.subheader .label.thin {
    display: inline;
    font-family: DistrictProBook;
    font-weight: 100;
    font-size: 24px;
}

.header .label.bold {
    display: inline;
    font-family: DistrictProBold;
    margin-top: -1px;
    font-size: 25px;
}

.header .label.date {
    display: inline;
    font-family: DistrictProBook;
    margin-top: -1px;
    font-size: 25px;
    float: right;
}

.header .label.created {
    position: absolute;
    width: 200px;
    top: 25px;
    left: 450px;
    text-align: center;
    font-family: DistrictProBook;
    color: var(--contrast-4);
    font-size: 11px;
}

.pdf.portrait .header .label.created {
    left: 300px;
}

.shiftrow {
    height: 50px;
    border-bottom: solid 2px black;
}

.shiftrow .picture {
    background-size: 100%;
    position: absolute;
    height: 50px;
    width: 50px;
    border-radius: 2px;
    cursor: grab !important;
}

.shiftrow .unassignedshift{
    width: 100%;
    padding: 2px 0px 0px 6px;
    font-size: 15px;
    color: var(--constrast-4);
    font-family: DistrictProBook;
}

.shiftrow .unassignedbreak {
    width: 100%;
    display: inline;
    padding-left: 6px;
    color: var(--contrast-4);
    font-family: DistrictProBook;
    font-size: 10px;
}

.shiftrow .shift {
    display: block;
    padding: 0px 0px 0px 60px;
    color: var(--contrast-4);
    font-family: DistrictProBook;
    font-size: 13px;
}

.shiftrow .shift .break{
    display: inline;
    margin-left: 4px;
    color: var(--contrast-4);
    font-family: DistrictProBook;
    font-size: 13px;
}

.shiftrow .actualwrapper {
    display: block;
    padding: 0px 0px 0px 60px;
    color: var(--contrast-4);
    font-family: DistrictProBook;
    font-size: 11px;
}

.shiftrow .actualwrapper .actual {
    display: inline;


    color: var(--contrast-4);
    font-family: DistrictProBook;
    font-size: 11px;
}

.shiftrow .actualwrapper .actual .fas {
    margin-right: 4px;
    font-size: 12px;
}

.shiftrow .actualwrapper .actualpauses {
    display: inline;
    padding-left: 4px;
    margin-left: 12px;
    color: var(--contrast-4);
    font-family: DistrictProBook;
    font-size: 11px;
}
.shiftrow .actualwrapper .actualpauses .fas {
    margin-right: 4px;
    font-size: 12px;
}

.pdf .shiftrow .shift {
    padding: 0px 0px 0px 6px;
}

.pdf .shiftrow .info {
    padding: 0px 0px 0px 6px;
}

.pdf .shiftrow .actualwrapper {
    padding: 0px 0px 0px 6px;
}

.shiftrow .info {
    display: block;
    padding: 0px 0px 0px 60px;
    font-family: DistrictProBook;
    font-size: 10px;
}

.shiftrow .task {
    padding: 0px 8px 0px 60px;
    color: var(--contrast-4);
    margin-top: -2px;
    font-family: DistrictProBook;
    font-size: 8px;
    white-space: nowrap;
    overflow:hidden;
    text-overflow: ellipsis;
}

.pdf .shiftrow .task {
    padding: 0px 8px 0px 6px;
}

.shiftrow .employeename {
    padding: 2px 0px 0px 60px;
    font-size: 13px;
    color: var(--contrast-4);
    font-family: DistrictProBook;
}

.pdf .shiftrow .employeename {
    padding: 2px 0px 0px 6px;
}

.shiftrow .employeename .lastname {
    display: inline;
    font-family: DistrictProBold;
}

.shiftrow .employeename .firstname {
    display: inline;
    font-size: 12.5px;
    font-family: DistrictProBook;
}

.header_column {
    color: var(--md);
    display: inline-block;
    width: 100%;
    padding-bottom: 2px;
    margin-bottom: 6px;
    font-weight: bold !important;
    border-bottom: 2px solid var(--md);
}

.left_column {
    display: inline-block;
    width: 100px;
    text-align: left;
}

.right_column {
    display: inline-block;
    width: 100px;
    text-align: right;
}
</style>
